export function getEnumValueByKey<T>(enumObj: T, key: keyof T): T[keyof T] {
    return enumObj[key];
}